export default "__VITE_ASSET__BcLs82tH__"